export const StorageKeys = {
  lastUserLookupSelection: 'lastUserLookupSelection',
  lastCompanyLookupSelection: 'lastCompanyLookupSelection',
};

export const StorageUtils = {
  lastUserLookupSelection: {
    get: () => sessionStorage.getItem(StorageKeys.lastUserLookupSelection),
    remove: () => sessionStorage.removeItem(StorageKeys.lastUserLookupSelection),
    /**
     *
     * @param {object} option
     * @param {string} option.value
     * @param {string} option.children
     */
    set: option => {
      if (option) {
        sessionStorage.setItem(
          StorageKeys.lastUserLookupSelection,
          JSON.stringify({
            value: option.value,
            label: option.children,
          }),
        );
      }
    },
  },
  lastCompanyLookupSelection: {
    get: () => sessionStorage.getItem(StorageKeys.lastCompanyLookupSelection),
    remove: () => sessionStorage.removeItem(StorageKeys.lastCompanyLookupSelection),
    /**
     *
     * @param {object} option
     * @param {string} option.value
     * @param {string} option.children
     */
    set: option => {
      if (option) {
        sessionStorage.setItem(
          StorageKeys.lastCompanyLookupSelection,
          JSON.stringify({
            value: option.value,
            label: option.children,
          }),
        );
      }
    },
  },
};
